import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'spe-step-header',
  imports: [NgClass],
  templateUrl: './step-header.component.html',
  styleUrl: './step-header.component.scss'
})
export class StepHeaderComponent {
  @Input() number!: number;
  @Input() title!: string;
  @Input() active: boolean = false;
  @Input() checked: boolean = false;
  @Input() blocked: boolean = false;

  @Output() eventClickChangeStep = new EventEmitter<number>();

  public clickChangeStep() {
    if ((this.active || this.checked) && !this.blocked) {
      this.eventClickChangeStep.emit();
    }
  }
}
